
import React from "react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { WorkoutType } from "@/models/WorkoutType";
import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";

interface SubscriptionFieldsHeaderProps {
  availableWorkoutTypes: WorkoutType[];
  selectedWorkoutTypeId: string;
  onWorkoutTypeSelect: (workoutTypeId: string) => void;
}

const SubscriptionFieldsHeader: React.FC<SubscriptionFieldsHeaderProps> = ({
  availableWorkoutTypes,
  selectedWorkoutTypeId,
  onWorkoutTypeSelect
}) => {
  const { t } = useTranslation();

  if (availableWorkoutTypes.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center gap-2">
          <Plus className="h-5 w-5" />
          {t('clients.addSubscription')}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex-1">
          <Select value={selectedWorkoutTypeId} onValueChange={onWorkoutTypeSelect}>
            <SelectTrigger data-testid="workout-type-select">
              <SelectValue placeholder={t('clients.filters.workoutTypePlaceholder')} />
            </SelectTrigger>
            <SelectContent>
              {availableWorkoutTypes.map((workoutType) => (
                <SelectItem key={workoutType.id} value={workoutType.id}>
                  <div className="flex items-center gap-2">
                    <div 
                      className="w-3 h-3 rounded-full" 
                      style={{ backgroundColor: workoutType.color }}
                    />
                    <span>{workoutType.name}</span>
                  </div>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
};

export default SubscriptionFieldsHeader;
